<script>
  export let close;

  addEventListener('keydown', (e)=>{
    if(e.key === 'Escape'){
      close();
    }
  })
</script>

<style>
.close-container{
  position: relative;
  margin: auto;
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 1rem;
}


.leftright{
  height: 4px;
  width: 50px;
  position: absolute;
  margin-top: 24px;
  background-color: #fff;
  border-radius: 2px;
  transform: rotate(45deg);
  transition: all .3s ease-in;
}

.rightleft{
  height: 4px;
  width: 50px;
  position: absolute;
  margin-top: 24px;
  background-color: #fff;
  border-radius: 2px;
  transform: rotate(-45deg);
  transition: all .3s ease-in;
}

label{
  color: white;
  font-family: Helvetica, Arial, sans-serif; 
  font-size: .6em;
  text-transform: uppercase;
  letter-spacing: 2px;
  transition: all .3s ease-in;
  opacity: 0;
}
.close{
  margin: 60px 0 0 5px;
  position: absolute;
}

.close-container:hover .leftright{
  transform: rotate(-45deg);
  background-color: #fff;
}
.close-container:hover .rightleft{
  transform: rotate(45deg);
  background-color: #fff;
}
.close-container:hover label{
  opacity: 1;
}


.close-position {
  position: absolute;
  z-index: 9999;
  right: 20px;
  top: 20px;
}
</style>

<div class="close-position" on:click={close}>
  <div class="close-container">
    <div class="leftright"></div>
    <div class="rightleft"></div>
    <label class="close">close</label>
  </div>
</div>
